<template>
  <div>
    <!--更换空间-->
    <el-row style="height: 40px;" v-if="showSpace">
      <img src="../../assets/images/index/roomIcon.png"
           style="margin-left: 1.3vw;margin-top: 10px;float: left;margin-right: 5px;">
      <div style="line-height: 40px;">
        <span style="color: rgba(7, 230, 248, 1)">{{ currentSpaceInfo.title }}</span>
        <a @touchstart="spaceTreeDisable = !spaceTreeDisable" @click="spaceTreeDisable = !spaceTreeDisable" class="pointer text-white"
           style="margin-left: 10px;">更换空间</a>
      </div>
      <space-choose @close="spaceTreeDisable = false"
                    @spaceClick="spaceClick"
                    ref="spaceChoose" v-show="spaceTreeDisable"></space-choose>
    </el-row>

    <div style="position: relative;">
      <vue-drag-resize :h="item.position.height * (winHeight / item.position.innerHeight)"
                       :isDraggable="false"
                       :isResizable="false"
                       :key="item.componentsName"
                       :parentH="winHeight"
                       :parentW="winWidth "
                       :w="item.position.width * (winWidth / item.position.innerWidth) "
                       :x="item.position.left * (winWidth / item.position.innerWidth) "
                       :y="item.position.top  * (winHeight / item.position.innerHeight)"
                       v-for="item in curComponents">
        <!--全景图-->
        <div style="height: 100%" v-if="item.componentsName === 'IndoorSetting'">
          <component :displaySetting="item.position.displaySetting ? item.position.displaySetting : {}"
                     :is="item.component"
                     :space-id="currentSpaceInfo.id"
                     @showDeviceDetail="showDeviceDetail"></component>
        </div>

        <border-corner v-else>
          <div :class="item.componentsName === 'AlarmInfo' ? 'alarmLists' : ''"
               :style="{textAlign: item.componentsName === 'AlarmInfo' ? (item.position.align ? item.position.align : 'right') : ''}"
               @mouseleave="onMouseLeave"
               @mouseover="onMouseOver(item)" slot="content"
               style="border:1px solid rgba(1,239,253,.6);height: 100%">
            <component :alignIcon="alignIcon" :is="item.component"
                       :textAlign="item.position.align ? item.position.align : 'right'"
                       @changeAlign="changeAlign"
                       @skipOverview="skipOverview"></component>
          </div>
        </border-corner>

      </vue-drag-resize>
    </div>

    <!--设备详情-->
    <device-detail :distribution-style="true" ref="deviceDetail"></device-detail>
  </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize';
import borderCorner from "@/components/style/BorderCorner";
import {getCurrentCustomPage} from "@/network/device-custom-page";
import {getSystematicByCodes} from "@/network/systematic";
import {saveOrUpdateCustomLayout} from "@/network/device-custom-layout";
import SpaceChoose from "@/views/overview/SpaceChoose";
import DeviceDetail from "@/components/device_details/comp/DeviceDetail";

export default {
  name: "Index",
  components: {VueDragResize, borderCorner, SpaceChoose, DeviceDetail},
  data() {
    return {
      code: "screen_template",
      curComponents: [], //当前页面展示组件
      winWidth: 0,
      winHeight: 0,
      alignIcon: false,
      align: 'right',
      mouseOverItem: {},
      spaceTreeDisable: false,
      currentSpaceInfo: {id: '0', title: '暂无空间'},
    }
  },
  created() {
    this.getCurrentCustomPage()
  },
  mounted() {
    this.winWidth = window.innerWidth;
    this.winHeight = window.innerHeight;
    window.onresize = () => {
      return (() => {
        this.winWidth = window.innerWidth;
        this.winHeight = window.innerHeight;
      })();
    };
  },
  computed: {
    showSpace() {
      return this.curComponents.filter(item => item.componentsName === 'IndoorSetting').length > 0
    }
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    //更换按钮
    spaceClick(data) {
      this.currentSpaceInfo = data
      this.spaceTreeDisable = false
    },
    //读取页面布局
    getCurrentCustomPage() {
      getCurrentCustomPage().then(res => {
        if (res.code === 0) {
          let deviceCustomLayouts = []
          getSystematicByCodes("capacity_system").then(systemRes => {
            if (systemRes.data.length > 0 && systemRes.data[0].val1 === 'true') {
              deviceCustomLayouts = res.data.deviceCustomLayouts;
            } else {
              deviceCustomLayouts = res.data.deviceCustomLayouts.filter(item => item.component !== 'Pue')
            }
            if (deviceCustomLayouts.length > 0) {
              deviceCustomLayouts.forEach(item => {
                const component = {};
                component.id = item.id;
                component.component = () => import('@/components/component/' + item.component + '.vue');
                component.componentsName = item.component;
                component.position = JSON.parse(item.params);
                this.curComponents.push(component)
              })
            }
          })
        }
      })
    },
    onMouseOver(item) {
      this.mouseOverItem = item;
      if (item.componentsName === 'AlarmInfo') {
        console.log(item);
        this.alignIcon = true;
      }
    },
    onMouseLeave() {
      this.alignIcon = false;
    },
    changeAlign(align) {
      const curComponent = this.curComponents.filter(item => item.id === this.mouseOverItem.id)[0]
      curComponent.position.align = align
      this.mouseOverItem.position.align = align
      let params = {
        id: this.mouseOverItem.id,
        params: JSON.stringify(this.mouseOverItem.position),
      }
      saveOrUpdateCustomLayout(params).then(res => {
        if (res.code === 0) {
          console.log(res);
        }
      })
      // this.align = align
    },
    //跳转到综合态势
    skipOverview(deviceInfo, tagCode) {
      // let route = ''
      // if (tagCode) {
      //   route = this.$router.resolve({
      //     path: '/overview',
      //     query: {spaceId: deviceInfo.spaceId, spaceName: deviceInfo.spaceName, tagCode: tagCode}
      //   });
      // } else {
      //   route = this.$router.resolve({path: '/realTime-alarm', query: {id: deviceInfo.id}});
      // }
      // window.open(route.href, '_blank');
      if (tagCode) {
        this.$router.push({
          path: '/overview',
          query: {spaceId: deviceInfo.spaceId, spaceName: deviceInfo.spaceName, tagCode: tagCode}
        })
      } else {
        this.$router.push({path: '/realTime-alarm', query: {id: deviceInfo.id}})
      }
    },
    showDeviceDetail(deviceId) {
      this.$refs.deviceDetail.showDeviceDetails(deviceId);
    },
  }
}
</script>

<style scoped>
.operation {
  width: 200px;
  margin: 20px;
  float: right;
  position: relative;
  background-color: rgba(255, 255, 255, .2);
  z-index: 99999;
}

.el-card {
  border: none;
  background-color: transparent;
  color: #fff;
}

.alarmLists {
  padding: 30px 35px 30px 10px;
  height: 100%;
  overflow-y: scroll;
}

.alarmLists::-webkit-scrollbar {
  display: none
}

.el-button {
  color: #fff;
  font-size: 0.9rem;
  background-color: rgba(41, 155, 255, .2);
  border: none;
}

.el-button:hover {
  background-color: rgba(41, 155, 255, .4) !important;
  color: #fff;
}

.vdr.active:before {
  outline: none;
}

.item a:hover {
  cursor: pointer;
}
</style>
